import { SOUND_EVENTS } from "@loot-os/api-contract";
import { Card, CardContent, CardHeader, CardTitle } from "@loot-os/ui/components/card";
import { Skeleton } from "@loot-os/ui/components/skeleton";

const GROUPS = [...new Set(SOUND_EVENTS.map((e) => e.group))];

/** `SoundList`'s cards with a placeholder per row, so the page keeps its height while loading. */
export function SoundListSkeleton() {
  return (
    <div className="grid gap-6" aria-busy="true">
      {GROUPS.map((group) => (
        <Card key={group}>
          <CardHeader>
            <CardTitle>{group}</CardTitle>
          </CardHeader>
          <CardContent className="divide-y">
            {SOUND_EVENTS.filter((e) => e.group === group).map((event) => (
              <div key={event.key} className="grid min-h-12 content-center py-3">
                <Skeleton className="h-6 w-full" />
              </div>
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
